import { render } from "./IconChevrolet.vue?vue&type=template&id=5a9a179f"
import script from "./IconChevrolet.vue?vue&type=script&lang=js"
export * from "./IconChevrolet.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__